import { useQuery } from '@tanstack/react-query'
import { Icon, Table } from '@bitcine/cinesend-theme'
import useTableFilters from '../../hooks/use_table_filters'
import { convertToDateTime } from '../../helpers/convert_date'
import { useNavigate } from 'react-router-dom'
import { v4 as uuid } from 'uuid'

const sortingOptions = [
  { label: 'Created at', key: 'created_at' },
  { label: 'Description', key: 'description' },
]

export default function ActivityLogsTable({ queryKey }) {
  const { queryString, searching, sorting, filtering, pagination } = useTableFilters({
    sortingOptions,
    enableSearch: true,
  })
  const { data, error, isLoading } = useQuery([`activity-logs${queryKey ? `?${queryKey}` : ''}`, queryString])
  const navigate = useNavigate()

  return (
    <Table
      status={{
        pending: isLoading,
        error: error,
        errorMessage: error?.message,
      }}
      widths={[200, 300, 240, 180]}
      header={{
        columns: [
          { text: 'User', key: '' },
          { text: 'Description', key: 'description' },
          { text: 'Model' },
          { text: 'Created At', key: 'created_at' },
        ],
        searching,
        sorting,
        filtering,
      }}
      body={{
        data: data?.data,
        row: {
          compact: false,
          spaced: true,
          render: [
            (data) => (
              <div className='text-xs'>
                <div>{data.causer?.name ?? 'System Created'}</div>
                <div className='text-gray-600 italic text-2xs'>{data.causer?.email}</div>
              </div>
            ),
            (data, index) => (
              <div className='first-letter:uppercase text-xs'>
                {data.activity_description.split('\n').map((line) => (
                  <p key={`${data.id}-${line}-${index}`}>{line}</p>
                ))}
              </div>
            ),
            (data) =>
              data.subject_route && data.subject_title ? (
                <div
                  className='cursor-pointer hover:text-black group text-gray-600 text-xs'
                  onClick={() => navigate(data.subject_route)}
                >
                  <div className='flex items-center space-x-1'>
                    <div className='group-hover:underline'>{data.subject_title}</div>
                    <Icon icon='arrow_right_alt' className='text-sm' />
                  </div>
                  <div className='text-2xs italic'>{data.subject_model_name}</div>
                </div>
              ) : null,
            (data) => <div className='text-xs'>{convertToDateTime(data.created_at)}</div>,
          ],
        },
        empty: {
          title: 'No activity logs found!',
          icon: 'list_alt',
        },
      }}
      paginate={{
        ...pagination,
        totalRows: data?.total,
      }}
    />
  )
}
